import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Grid, Link, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
// sections
import { setUserSession } from '../utils/common';
import { LoginForm } from '../sections/auth/login';


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));



// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  const navigate = useNavigate();
const handleClicks = () => {
  navigate('/login', { replace: true });
};



  return (
    <>
      <Helmet>
        <title> User Activated | SmartShield </title>
      </Helmet>

      {/* <main className='w-full h-screen flex flex-row'>
        <section className='w-full md:w-5/12 flex flex-col items-center py-20 px-14 space-y-7 mt-28'>
          <img src='/assets/DCN.png' alt='KPK Logo' className='w-60' />
          <LoginForm />
          <div className='absolute bottom-14'>
            <div className='flex flex-col items-center space-y-3'>
              <h3 className='font-medium text-blue-900 text-xs'>Powered By</h3>
              <img src='/assets/chain.svg' className='w-40' alt='ChainSmart'/>
            </div>
          </div>
        </section>
        <section className='md:w-full hidden w-0 md:flex md:justify-center'>
          <div className='absolute flex flex-col bottom-16 items-center text-center text-blue-900'>
            <h2 className='font-bold text-lg'>Protect your business with SmartShield</h2>
            <h3 className='font-semibold text-xs'>the intelligent Blockchain based data integrity system</h3>
          </div>
          <img src='/assets/smartshield.jpg' alt='Smartshield' className='h-full w-full object-cover'/>
        </section>
      </main> */}

      <Grid
        xs={12}
        item
        md={6}
        style={{
          // backgroundColor: '',
          backgroundImage: 'url(/assets/Signup.png)',
          backgroundSize: 'cover', // Adjust this as needed
          backgroundPosition: 'absolute', // Adjust this as needed
          height: '100vh',
          zIndex: '1',
        }}
      >
        {''}
        <div className="relative z-100 container mx-auto px-4 h-full">
          <div className="relative flex content-center items-center justify-center h-full">
            <div className="w-full lg:w-4/12 px-4">
              <div
                className="relative flex flex-col items-center min-w-0 break-words w-full mb-6 shadow-2xl shadow-blue-500/50 rounded-lg bg-blueGray-200 border-0"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 1)', // You can adjust the background color and opacity here
                }}
              >
                <div className="relative rounded-t mb-0 px-6 py-6">
                  <img src="/assets/smartshild.png" alt="smartshield Logo" className="w-140" />
                  <div className="text-center mb-3">
                    <h4 className="text-blueGray-500 text-xl font-bold">Welcome!</h4>
                  </div>
                  <hr className="mt-6 border-b-1 border-blueGray-300" />
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0 flex flex-col items-center">
                  <a className="flex auto items-center text-center text-blue-400">
                    <small>Your account has been created successfully, Please log in to complete the process.</small>
                  </a>
                  <Button className="mt-4 shadow-blue-500/50" onClick={handleClicks}>
                    Login
                  </Button>
                </div>
                <Typography variant="body2" align="center" style={{ color: '#12A2CE' }}>
                  {' '}
                  &copy; 2024 ChainSmart - All Rights Reserved
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </Grid>
    </>
  );
}